import e from "../../../node_modules/.pnpm/lodash-es@4.17.23/node_modules/lodash-es/merge.js";
import t from "../locale/en_US.js";
import { CONFIG_PROVIDER_DIRECTION_INJECT_KEY as n, CONFIG_PROVIDER_LOCALE_INJECTION_KEY as r, CONFIG_PROVIDER_TELEPORT_RENDER_DISABLED_INJECT_KEY as i } from "./injectionKeys.js";
import { computed as a, defineComponent as o, inject as s, provide as c, renderSlot as l } from "vue";
//#region src/components/ui/config-provider/ConfigProvider.vue?vue&type=script&setup=true&lang.ts
var u = /* @__PURE__ */ o({
	__name: "ConfigProvider",
	props: {
		locale: {},
		dir: {},
		teleportRenderDisabled: { type: Boolean },
		directivesProvides: {}
	},
	setup(o) {
		let u = o, d = s(r, void 0), f = a(() => {
			let n = (u.directivesProvides && typeof u.directivesProvides == "object" ? Reflect.get(u.directivesProvides, r) : void 0)?.value ?? u.locale;
			return e({}, d?.value ?? t, n);
		}), p = a(() => u.dir || f.value.dir), m = a(() => (u.directivesProvides && typeof u.directivesProvides == "object" ? Reflect.get(u.directivesProvides, i) : void 0)?.value ?? u.teleportRenderDisabled ?? !1);
		return c(n, p), c(r, f), c(i, m), (e, t) => l(e.$slots, "default");
	}
});
//#endregion
export { u as default };

//# sourceMappingURL=ConfigProvider_vue.js.map